"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateShiftAttributeUpdate = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const query = (0, graphql_tag_1.default) `mutation ShiftAttributeUpdateMutation (
  $workspace: ID!,
  $name: String!,
  $shortName: String!,
  $description: String,
  $id: ID!
  $options: CustomAttributeOptionsInput,
  $customId: String,
) {
  shiftAttributeUpdate(
    workspace: $workspace,
    options: $options,
    customId: $customId,
    description: $description,
    shortName: $shortName,
    name: $name,
    id: $id
  ) {
    id
    name
    description
    shortName
    customId
    type
    options {
      values
      countTowardsPeriod
    }
    hidden
  }
}`;
const mutateShiftAttributeUpdate = async (args) => {
    const { data, errors } = await (0, apollo_1.mutate)(query, {
        variables: args
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.shiftAttributeUpdate;
};
exports.mutateShiftAttributeUpdate = mutateShiftAttributeUpdate;
exports.default = exports.mutateShiftAttributeUpdate;
